import { Place } from './place';

export type User = {
  userId: string;
  username: string;
  displayName: string;
  photoUrl: string;
  hometown: Place;
  public: boolean;
  createdAt: Date;
  updatedAt: Date;
  numFollowers?: number;
  numFollowing?: number;
  groupIds?: string[];
  adminGroupIds?: string[];
};

export type UserPrivate = {
  userId: string;
  email: string;
  birthdate: Date;
  createdAt: Date;
  updatedAt: Date;
  phoneNumber?: string;
  notificationToken?: string;
};

export type UserFormData = Pick<
  User,
  'hometown' | 'public' | 'username' | 'photoUrl' | 'displayName'
>;
export type UserPrivateFormData = Pick<UserPrivate, 'birthdate' | 'phoneNumber'>;
export type UserInfo = Pick<User, 'userId' | 'displayName' | 'photoUrl'>;

export const DELETED_USER_INFO = {
  userId: 'deleted-user',
  displayName: 'Deleted User',
  photoUrl: '',
} as const satisfies UserInfo;
export const DELETED_USER_ID = DELETED_USER_INFO.userId;

export enum PersonType {
  USER = 'USER',
  CONTACT = 'CONTACT',
}

export type Person = {
  personId: string;
  type: PersonType;
  displayName: string;
  photoUrl: string;
  phoneNumber?: string;
  username?: string;
};
